import React from 'react'

import { isEmpty } from 'ramda'
import { components, IndicatorSeparatorProps, GroupBase } from 'react-select'

import { SelectOptionInterface } from '@customTypes'

export const getIndicatorSeparator = <
  Opt extends SelectOptionInterface,
  IsMulti extends boolean,
  Group extends GroupBase<Opt>
>({ shouldHide = false, disableWhenHasValue = false }) => {
  const IndicatorSeparator = React.memo(
    (props: IndicatorSeparatorProps<Opt, IsMulti, Group>) => {
      const { getValue } = props
      const isSelectEmpty = getValue().every(isEmpty)


      if ((disableWhenHasValue && !isSelectEmpty) || isSelectEmpty || shouldHide) {
        return null
      }

      return (
        <components.IndicatorSeparator {...props} />
      )
    }
  )

  IndicatorSeparator.displayName = 'IndicatorSeparator'

  return IndicatorSeparator as typeof components.IndicatorSeparator
}
